// ADD FORM FIELDS

import { Lang, Page, Operation } from "../translations/types";
import {
  ADD_FORM_FIELDS_TRANSLATIONS,
  FORM_VALIDATION_TRANSLATIONS,
  getPageTranslationText,
} from "../translations/util";

const createLocationTranslations = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LOCATION,
  op: Operation.CREATE,
});

function fetchSquelchFieldsDropDownValues({
  fieldName,
  dfsiVersion,
  channelMode,
  cdcValue,
  ctcValue,
}: {
  fieldName?: string;
  dfsiVersion?: number;
  channelMode: string;
  cdcValue: string;
  ctcValue: string;
}) {
  let result = ["None"];
  if (channelMode && dfsiVersion && channelMode === "Analog") {
    if (dfsiVersion === 1) {
      result = ["None"];
    }
    if (dfsiVersion === 2) {
      if (
        (cdcValue && cdcValue !== "None") ||
        (ctcValue && ctcValue !== "None")
      ) {
        result = ["None"];
      } else {
        result =
          fieldName === "CTC-SQUELCH-SYSTEM"
            ? ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
                "CTC-SQUELCH-SYSTEM"
              ].items
            : ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
                "CDC-SQUELCH-SYSTEM"
              ].items;
      }
    }
  }
  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_XSSI_CONNECTION_FORM_FIELDS = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["CONNECTION-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["CONNECTION-ID"]
            .tooltipText,
        name: "CONNECTION-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .tooltipText,
        name: "RADIO-IPV4-ADDR",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .label
        ),
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"]
            .tooltipText,
        name: "RADIO-RFSS-ID",
        min: 1,
        max: 65535,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"]
            .tooltipText,
        name: "RADIO-SYSTEM-ID",
        min: 1,
        max: 4095,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"]
            .tooltipText,
        name: "RADIO-WACN-ID",
        min: 1,
        max: 1048575,
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RADIO-RFSS-4-HEX-DIGIT"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RADIO-RFSS-4-HEX-DIGIT"
          ].tooltipText,
        name: "RADIO-RFSS-4-HEX-DIGIT",
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-RFSS-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-RFSS-ID"]
            .tooltipText,
        name: "IWF-RFSS-ID",
        min: 1,
        max: 65535,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-SYSTEM-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-SYSTEM-ID"]
            .tooltipText,
        name: "IWF-SYSTEM-ID",
        min: 1,
        max: 4095,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-WACN-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-WACN-ID"]
            .tooltipText,
        name: "IWF-WACN-ID",
        min: 1,
        max: 1048575,
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["POLLING-ENABLED"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["POLLING-ENABLED"]
            .tooltipText,
        name: "POLLING-ENABLED",
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-CONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-CONNECTED"
          ].tooltipText,
        name: "POLLING-INTERVAL-CONNECTED",
        min: 1,
        max: 300,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-DISCONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-DISCONNECTED"
          ].tooltipText,
        name: "POLLING-INTERVAL-DISCONNECTED",
        min: 1,
        max: 300,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RESPONSES-BEFORE-CONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RESPONSES-BEFORE-CONNECTED"
          ].tooltipText,
        name: "RESPONSES-BEFORE-CONNECTED",
        min: 1,
        max: 100,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "MISSED-RESPONSES-BEFORE-DISCONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "MISSED-RESPONSES-BEFORE-DISCONNECTED"
          ].tooltipText,
        name: "MISSED-RESPONSES-BEFORE-DISCONNECTED",
        min: 1,
        max: 100,
      },
      {
        type: "MULTISELECT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .tooltipText,
        name: "VOCODER-MODES",
        invalidText: FORM_VALIDATION_TRANSLATIONS.VocoderValidation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .label
        ),
        isInputInvalid: (list?: string[] | string) => {
          if (!list || list.length === 0) return true;

          const POSSIBLE_VOCODER_MODES = ["FR", "HR", "Native", "Phase 1"];
          if (POSSIBLE_VOCODER_MODES.some((r) => list.includes(r)))
            return false;

          return true;
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const REUSE_XSSI_CONNECTION_FORM_FIELDS = [
  {
    cols: 2,
    fields: [
      {
        type: "ORG-DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "SELECTED-ORGANISATION"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "SELECTED-ORGANISATION"
          ].tooltipText,
        isInputInvalid: (val?: string) => {
          return !val || val.length === 0;
        },
        name: "",
      },
      {
        type: "CONNECTION-DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "REUSED-CONNECTION"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "REUSED-CONNECTION"
          ].tooltipText,
        isInputInvalid: (val?: string) => {
          return !val || val.length === 0;
        },
        name: "CONNECTION-ID",
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["CONNECTION-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["CONNECTION-ID"]
            .tooltipText,
        name: "CONNECTION-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .tooltipText,
        name: "RADIO-IPV4-ADDR",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .label
        ),
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"]
            .tooltipText,
        name: "RADIO-RFSS-ID",
        min: 1,
        max: 65535,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"]
            .tooltipText,
        name: "RADIO-SYSTEM-ID",
        min: 1,
        max: 4095,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"]
            .tooltipText,
        name: "RADIO-WACN-ID",
        min: 1,
        max: 1048575,
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RADIO-RFSS-4-HEX-DIGIT"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RADIO-RFSS-4-HEX-DIGIT"
          ].tooltipText,
        name: "RADIO-RFSS-4-HEX-DIGIT",
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-RFSS-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-RFSS-ID"]
            .tooltipText,
        name: "IWF-RFSS-ID",
        min: 1,
        max: 65535,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-SYSTEM-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-SYSTEM-ID"]
            .tooltipText,
        name: "IWF-SYSTEM-ID",
        min: 1,
        max: 4095,
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-WACN-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-WACN-ID"]
            .tooltipText,
        name: "IWF-WACN-ID",
        min: 1,
        max: 1048575,
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["POLLING-ENABLED"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["POLLING-ENABLED"]
            .tooltipText,
        name: "POLLING-ENABLED",
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-CONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-CONNECTED"
          ].tooltipText,
        name: "POLLING-INTERVAL-CONNECTED",
        min: 1,
        max: 300,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-DISCONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-DISCONNECTED"
          ].tooltipText,
        name: "POLLING-INTERVAL-DISCONNECTED",
        min: 1,
        max: 300,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RESPONSES-BEFORE-CONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RESPONSES-BEFORE-CONNECTED"
          ].tooltipText,
        name: "RESPONSES-BEFORE-CONNECTED",
        min: 1,
        max: 100,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "MISSED-RESPONSES-BEFORE-DISCONNECTED"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "MISSED-RESPONSES-BEFORE-DISCONNECTED"
          ].tooltipText,
        name: "MISSED-RESPONSES-BEFORE-DISCONNECTED",
        min: 1,
        max: 100,
      },
      {
        type: "MULTISELECT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .tooltipText,
        name: "VOCODER-MODES",
        invalidText: FORM_VALIDATION_TRANSLATIONS.VocoderValidation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .label
        ),
        isInputInvalid: (list?: string[] | string) => {
          if (!list || list.length === 0) return true;

          const POSSIBLE_VOCODER_MODES = ["FR", "HR", "Native", "Phase 1"];
          if (POSSIBLE_VOCODER_MODES.some((r) => list.includes(r)))
            return false;

          return true;
        },
      },
    ],
  },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_DFSI_GROUP_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "TEXT",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["IWF-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["IWF-ID"].tooltipText,
        name: "IWF-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
        disabled: true,
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["ENCRYPTION-ENABLED"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["ENCRYPTION-ENABLED"]
            .tooltipText,
        name: "ENCRYPTION-ENABLED",
      },
      {
        type: "NUMBER",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP].SLN.label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP].SLN.tooltipText,
        name: "SLN",
        min: 0,
        max: 65535,
        isInputInvalid: ({ val }: { val?: number }) => {
          if (!val && val !== 0) return true;

          return val < 0 || val > 65535;
        },
      },
      {
        type: "COMBO-DROPDOWN",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP].FORMAT.label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP].FORMAT.tooltipText,
        name: "FORMAT",
        items: ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP].FORMAT.items,
        isInputInvalid: (val?: string) => {
          return !val || val.length === 0;
        },
      },
      {
        type: "TEXT-CUSTOM",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["DFSI-LOGICAL-GID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["DFSI-LOGICAL-GID"]
            .tooltipText,
        name: "DFSI-LOGICAL-GID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "MULTISELECT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["CHANNEL-IDS"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["CHANNEL-IDS"]
            .tooltipText,
        name: "CHANNEL-IDS",
        invalidText: null,
        items: [],
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["DFSI-GROUP-NAME"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["DFSI-GROUP-NAME"]
            .tooltipText,
        name: "DFSI-GROUP-NAME",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_DFSI_CHANNEL_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "CUSTOM-DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CONNECTION-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CONNECTION-ID"]
            .tooltipText,
        name: "CONNECTION-ID",
        invalidText: null,
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CONNECTION-ID"]
            .items,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["DFSI-VERSION"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["DFSI-VERSION"]
            .tooltipText,
        name: "DFSI-VERSION",
        invalidText: null,
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["DFSI-VERSION"].items,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        disabled: () => true,
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-ID"]
            .tooltipText,
        name: "CHANNEL-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-MODE"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-MODE"]
            .tooltipText,
        name: "CHANNEL-MODE",
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-MODE"].items,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isInputInvalid: (val?: string, _?: string) => {
          if (!val) return true;

          return !(val === "Analog" || val === "Digital");
        },
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["OTA-GROUP-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["OTA-GROUP-ID"]
            .tooltipText,
        name: "OTA-GROUP-ID",
        min: 1,
        max: 65535,
        disabled: (channelMode?: string) => {
          return !channelMode || channelMode === "Analog";
        },
        isInputInvalid: (channelMode?: string, val?: number) => {
          if (!channelMode) return true;
          if (channelMode === "Analog") return false;

          if (!val) return true;

          if (val < 1 || val > 65535) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "CHECKBOX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CARRIER-SQUELCH"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CARRIER-SQUELCH"]
            .tooltipText,
        name: "CARRIER-SQUELCH",
        disabled: (channelMode?: string, dfisVersion?: number) => {
          if (!channelMode || channelMode === "Digital") {
            return true;
          }
          if (!channelMode || channelMode === "Analog") {
            if (!dfisVersion || dfisVersion === 1) {
              return true;
            }
          }
          return false;
        },
        isInputInvalid: (channelMode?: string, dfsiVersion?: number) => {
          if (!channelMode && !dfsiVersion) return true;
          return false;
        },
        invalidText: null,
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "OUTBOUND-NETWORK-ACCESS-CODE"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "OUTBOUND-NETWORK-ACCESS-CODE"
          ].tooltipText,
        name: "OUTBOUND-NETWORK-ACCESS-CODE",
        min: 0,
        max: 4095,
        disabled: (channelMode?: string) => {
          return !channelMode || channelMode === "Analog";
        },
        isInputInvalid: (channelMode?: string, val?: number) => {
          if (!channelMode) return true;
          if (channelMode === "Analog") return false;
          if (val === 0) return false;

          if (!val) return true;

          if (val === 3966 || val === 3967) return true;

          if (val < 0 || val > 4095) return true;

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.newtworkAccessCodeValidation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "OUTBOUND-NETWORK-ACCESS-CODE"
          ].label,
          "(0-4095)",
          "0xF7E (3966)",
          "0xF7F (3967)"
        ),
      },
      {
        type: "HEX",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "INBOUND-NETWORK-ACCESS-CODE"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "INBOUND-NETWORK-ACCESS-CODE"
          ].tooltipText,
        name: "INBOUND-NETWORK-ACCESS-CODE",
        min: 0,
        max: 4095,
        disabled: (channelMode?: string) => {
          return !channelMode || channelMode === "Analog";
        },
        isInputInvalid: (channelMode?: string, val?: number) => {
          if (!channelMode) return true;
          if (channelMode === "Analog") return false;
          if (val === 0) return false;

          if (!val) return true;

          if (val === 3966 || val === 3967) return true;

          if (val < 0 || val > 4095) return true;

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.newtworkAccessCodeValidation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "INBOUND-NETWORK-ACCESS-CODE"
          ].label,
          "(0-4095)",
          "0xF7E (3966)",
          "0xF7F (3967)"
        ),
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "COMBO-DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CTC-SQUELCH-SYSTEM"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CTC-SQUELCH-SYSTEM"]
            .tooltipText,
        name: "CTC-SQUELCH-SYSTEM",
        comboItems: fetchSquelchFieldsDropDownValues,
        disabled: (
          channelMode?: string,
          dfsiVersion?: number,
          isChecked?: boolean
        ) => {
          return !channelMode || channelMode === "Digital" || isChecked;
        },
        isInputInvalid: (channelMode?: string, val?: string) => {
          if (!channelMode) return true;
          if (channelMode === "Digital") return false;
          return !val || val.length === 0;
        },
      },
      {
        type: "COMBO-DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CDC-SQUELCH-SYSTEM"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CDC-SQUELCH-SYSTEM"]
            .tooltipText,
        name: "CDC-SQUELCH-SYSTEM",
        comboItems: fetchSquelchFieldsDropDownValues,
        disabled: (
          channelMode?: string,
          dfsiVersion?: number,
          isChecked?: boolean
        ) => {
          return !channelMode || channelMode === "Digital" || isChecked;
        },
        isInputInvalid: (channelMode?: string, val?: string) => {
          if (!channelMode) return true;
          if (channelMode === "Digital") return false;

          return !val || val.length === 0;
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_DFSI_CONNECTION_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["CONNECTION-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["CONNECTION-ID"]
            .tooltipText,
        name: "CONNECTION-ID",
        isInputInvalid: ({ val }: { version?: number; val?: string }) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DFSI-VERSION"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DFSI-VERSION"]
            .tooltipText,
        name: "DFSI-VERSION",
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DFSI-VERSION"]
            .items,
        isInputInvalid: ({ val }: { version?: number; val?: string }) => {
          if (!val || val.length === 0) return true;

          return +val < 1 || +val > 2;
        },
        invalidText: null,
      },
      {
        type: "DROPDOWN",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["IWF-ROLE"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["IWF-ROLE"]
            .tooltipText,
        name: "IWF-ROLE",
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["IWF-ROLE"].items,
        isInputInvalid: (val: string) =>
          !val || (val.length === 0 && !["HOST", "STATION"].includes(val)),
        invalidText: null,
      },
    ],
  },
  {
    cols: 3,
    fields: [
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-IPV4-ADDR"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-IPV4-ADDR"
          ].tooltipText,
        name: "HOST-CONTROL-IPV4-ADDR",
        isInputInvalid: ({
          val,
          role,
        }: {
          version?: number;
          val?: string;
          role?: string;
        }) => {
          if (role === "Station") return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-IPV4-ADDR"
          ].label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return role === "Station";
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-PORT"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-PORT"
          ].tooltipText,
        name: "HOST-CONTROL-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({
          val,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (role === "Station") return false;
          if (!val) return true;
          return val < 1024 || val > 65535;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return role === "Station";
        },
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-VOICE-IPV4-ADDR"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-VOICE-IPV4-ADDR"
          ].tooltipText,
        name: "HOST-VOICE-IPV4-ADDR",
        isInputInvalid: ({
          val,
          role,
        }: {
          version?: number;
          val?: string;
          role?: string;
        }) => {
          if (role === "Station") return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-VOICE-IPV4-ADDR"
          ].label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return role === "Station";
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["VOICE-PORT"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["VOICE-PORT"]
            .tooltipText,
        name: "VOICE-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1024 || val > 65535;
        },
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-IPV4-ADDR"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-IPV4-ADDR"]
            .tooltipText,
        name: "DATA-IPV4-ADDR",
        isInputInvalid: ({
          version,
          val,
        }: {
          version?: number;
          val?: string;
        }) => {
          if (version === 1) return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-IPV4-ADDR"]
            .label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return dfsiVersion && +dfsiVersion === 1;
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-PORT"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-PORT"]
            .tooltipText,
        name: "DATA-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({
          val,
          version,
        }: {
          version?: number;
          val?: number;
        }) => {
          if (version === 1) return false;

          if (!val) return true;

          return val < 1024 || val > 65535;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (+!dfsiVersion && !role) return true;
          return dfsiVersion && +dfsiVersion === 1;
        },
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-IPV4-ADDR"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-IPV4-ADDR"
          ].tooltipText,
        name: "FIXED-STATION-CONTROL-IPV4-ADDR",
        isInputInvalid: ({ val }: { version?: number; val?: string }) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-IPV4-ADDR"
          ].label
        ),
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOICE-IPV4-ADDR"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOICE-IPV4-ADDR"
          ].tooltipText,
        name: "FIXED-STATION-VOICE-IPV4-ADDR",
        isInputInvalid: ({
          version,
          val,
          role,
        }: {
          version?: number;
          val?: string;
          role?: string;
        }) => {
          if (version === 2 && role === "Host") return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOICE-IPV4-ADDR"
          ].label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return dfsiVersion && +dfsiVersion === 2 && role === "Host";
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-PORT"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-PORT"
          ].tooltipText,
        name: "FIXED-STATION-CONTROL-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1024 || val > 65535;
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-TX-TIMER"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-TX-TIMER"
          ].tooltipText,
        name: "CONNECTIVITY-TX-TIMER",
        min: 1,
        max: 255,
        isInputInvalid: ({
          version,
          val,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (version === 1) return false;
          if (version === 2 && role === "Station") return false;
          if (!val) return true;
          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion || dfsiVersion === 1) return true;
          return +dfsiVersion === 2 && role === "Station";
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-LOSS-LIMIT"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-LOSS-LIMIT"
          ].tooltipText,
        name: "CONNECTIVITY-LOSS-LIMIT",
        min: 1,
        max: 100,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1 || val > 100;
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FS-HEARTBEAT-PERIOD"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FS-HEARTBEAT-PERIOD"
          ].tooltipText,
        name: "FS-HEARTBEAT-PERIOD",
        min: 1,
        max: 255,
        isInputInvalid: ({
          val,
          version,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (version === 2 || (version === 1 && role === "Station"))
            return false;

          if (!val) return true;

          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion) return true;
          return (
            +dfsiVersion === 2 || (+dfsiVersion === 1 && role === "Station")
          );
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-HEARTBEAT-PERIOD"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-HEARTBEAT-PERIOD"
          ].tooltipText,
        name: "HOST-HEARTBEAT-PERIOD",
        min: 1,
        max: 255,
        isInputInvalid: ({
          val,
          version,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (version === 2 || (version === 1 && role === "Station"))
            return false;

          if (!val) return true;

          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion) return true;
          return (
            +dfsiVersion === 2 || (+dfsiVersion === 1 && role === "Station")
          );
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-RETRY-TIME"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-RETRY-TIME"
          ].tooltipText,
        name: "CONTROL-RETRY-TIME",
        min: 1,
        max: 5000,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1 || val > 5000;
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-ATTEMPT-LIMIT"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-ATTEMPT-LIMIT"
          ].tooltipText,
        name: "CONTROL-ATTEMPT-LIMIT",
        min: 1,
        max: 10,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1 || val > 10;
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "OUTBOUND-MAX-CAI-DATA-BLOCKS"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "OUTBOUND-MAX-CAI-DATA-BLOCKS"
          ].tooltipText,
        name: "OUTBOUND-MAX-CAI-DATA-BLOCKS",
        min: 1,
        max: 128,
        isInputInvalid: ({
          val,
          version,
        }: {
          version?: number;
          val?: number;
        }) => {
          if (version === 1) return false;

          if (!val) return true;

          return val < 1 || val > 128;
        },
        disabled: (dfsiVersion?: number) => {
          if (!dfsiVersion) return true;
          return +dfsiVersion === 1;
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "INBOUND-MAX-CAI-DATA-BLOCKS"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "INBOUND-MAX-CAI-DATA-BLOCKS"
          ].tooltipText,
        name: "INBOUND-MAX-CAI-DATA-BLOCKS",
        min: 1,
        max: 128,
        isInputInvalid: ({
          val,
          version,
        }: {
          version?: number;
          val?: number;
        }) => {
          if (version === 1) return false;
          if (!val) return true;

          return val < 1 || val > 128;
        },
        disabled: (dfsiVersion?: number) => {
          if (!dfsiVersion) return true;
          return +dfsiVersion === 1;
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "ACKNOWLEDGEMENT-DELAY"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "ACKNOWLEDGEMENT-DELAY"
          ].tooltipText,
        name: "ACKNOWLEDGEMENT-DELAY",
        min: 0,
        max: 2,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val && val !== 0) return true;

          return val < 0 || val > 2;
        },
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["INBOUND-REPEAT"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["INBOUND-REPEAT"]
            .tooltipText,
        name: "INBOUND-REPEAT",
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOTER-REPORTING-PERIOD"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOTER-REPORTING-PERIOD"
          ].tooltipText,
        name: "FIXED-STATION-VOTER-REPORTING-PERIOD",
        min: 1,
        max: 255,
        isInputInvalid: ({ val, role }: { val?: number; role?: string }) => {
          if (role === "Host") return false;
          if (!val) return true;
          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (+!dfsiVersion || !role) return true;
          return (
            (role === "Host" && dfsiVersion === 1) ||
            (role === "Host" && dfsiVersion === 2)
          );
        },
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL"
          ].tooltipText,
        name: "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL",
        min: 1,
        max: 255,
        isInputInvalid: ({
          version,
          val,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (
            (role === "Host" && version === 1) ||
            (role === "Host" && version === 2) ||
            (role === "Station" && version === 1)
          ) {
            return false;
          }
          if (!val) return true;
          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (+!dfsiVersion || !role) return true;
          return (
            (role === "Host" && dfsiVersion === 1) ||
            (role === "Host" && dfsiVersion === 2) ||
            (role === "Station" && dfsiVersion === 1)
          );
        },
      },
    ],
  },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_LOCATIONS_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label: createLocationTranslations.labels.id,
        tooltipText: createLocationTranslations.tooltipText.id,
        name: createLocationTranslations.names.id,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label: createLocationTranslations.labels.name,
        tooltipText: createLocationTranslations.tooltipText.name,
        name: createLocationTranslations.names.locationName,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label: createLocationTranslations.labels.domain,
        tooltipText: createLocationTranslations.tooltipText.domain,
        name: createLocationTranslations.names.domain,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_ORGANIZATION_MAPPING_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["IWF-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["IWF-ID"].tooltipText,
        name: "IWF-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["ORG-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["ORG-ID"].tooltipText,
        name: "ORG-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_ORGANIZATION_FORM_FIELDS: any = [
  {
    type: "TEXT",
    label: ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG]["Organisation ID"].label,
    tooltipText:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG]["Organisation ID"].tooltipText,
    name: "Organisation ID",
    isInputInvalid: (val?: string) => {
      if (!val || val.length === 0) return true;

      return false;
    },
    invalidText: null,
  },
  {
    type: "TEXT",
    label: ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG]["Organisation Name"].label,
    tooltipText:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.ORG]["Organisation Name"].tooltipText,
    name: "Organisation Name",
    isInputInvalid: (val?: string) => {
      if (!val || val.length === 0) return true;

      return false;
    },
    invalidText: null,
  },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_CANNED_MESSAGES_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.CANNED_MESSAGE]["MSG-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.CANNED_MESSAGE]["MSG-ID"]
            .tooltipText,
        name: "MSG-ID",
        min: 0,
        max: 65535,
      },
      {
        type: "TEXTAREA",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.CANNED_MESSAGE]["CANNED-TEXT"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.CANNED_MESSAGE]["CANNED-TEXT"]
            .tooltipText,
        name: "CANNED-TEXT",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
      },
    ],
  },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_LMR_GROUPS_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "TEXT",
        id: "TG-ID",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["TG-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["TG-ID"].tooltipText,
        name: "TG-ID",
        isInputInvalid: (val?: string) => !val || val?.length === 0,
        invalidText: null,
        required: true,
      },
      {
        type: "DROPDOWN",
        id: "LMR-NW-TYPE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"]
            .tooltipText,
        name: "LMR-NW-TYPE",
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"].items,
        isInputInvalid: (val?: string) => !val || val?.length === 0,
        invalidText: null,
        required: true,
      },
      {
        type: "TEXT",
        id: "MAPPED-MCPTT-GID",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["MAPPED-MCPTT-GID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["MAPPED-MCPTT-GID"]
            .tooltipText,
        name: "MAPPED-MCPTT-GID",
        isInputInvalid: (val?: string) => !val || val?.length === 0,
        invalidText: null,
        required: true,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_LMR_USERS_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["LMR-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["LMR-ID"].tooltipText,
        name: "LMR-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "TEXT",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["LMR-NW-TYPE"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["LMR-NW-TYPE"]
            .tooltipText,
        name: "LMR-NW-TYPE",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MAPPED-MCPTT-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MAPPED-MCPTT-ID"]
            .tooltipText,
        name: "MAPPED-MCPTT-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["DISPLAY-NAME"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["DISPLAY-NAME"]
            .tooltipText,
        name: "DISPLAY-NAME",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "TOGGLE",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MUTUAL-AID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MUTUAL-AID"].tooltipText,
        name: "MUTUAL-AID",
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_MCPTT_GROUPS_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP]["MCPTT-GID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP]["MCPTT-GID"]
            .tooltipText,
        name: "MCPTT-GID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "MappedValueDropdown",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].tooltipText,
        name: "SELECT A MAPPED-FIELD",
        required: false,
        dropdownDisabled: false,
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].items,
        placeholder:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].placeholder,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isInputInvalid: (items: string[] | undefined, data: any) => {
          if (items?.find((val) => data[val] || data[val].length !== 0)) {
            return false;
          }
          return true;
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_MCPTT_USER_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "TEXT",
        label: ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MCPTT-ID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MCPTT-ID"].tooltipText,
        name: "MCPTT-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["DISPLAY-NAME"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["DISPLAY-NAME"]
            .tooltipText,
        name: "DISPLAY-NAME",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "DROPDOWN",
        id: "MAPPED-FIELDS",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["SELECT A MAPPED-FIELD"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["SELECT A MAPPED-FIELD"]
            .tooltipText,
        name: "MAPPED-FIELD",
        items:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["SELECT A MAPPED-FIELD"]
            .items,
        isInputInvalid: (val?: string) => !val || val?.length === 0,
        invalidText: null,
        required: true,
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MUTUAL-AID"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MUTUAL-AID"]
            .tooltipText,
        name: "MUTUAL-AID",
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_MCPTT_USER_MAPPED_FIELDS: any = [
  {
    type: "TEXT",
    label: ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-P25-ID"].label,
    tooltipText:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-P25-ID"]
        .tooltipText,
    name: "MAPPED-P25-ID",
    isInputInvalid: (val?: string) => {
      if (!val || val.length === 0) return true;
      return false;
    },
    invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-P25-ID"),
  },
  {
    type: "TEXT",
    label:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DFSI-ID"].label,
    tooltipText:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DFSI-ID"]
        .tooltipText,
    name: "MAPPED-DFSI-ID",
    isInputInvalid: (val?: string) => {
      if (!val || val.length === 0) return true;
      return false;
    },
    invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-DFSI-ID"),
  },
  {
    type: "TEXT",
    label:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-ROIP-ID"].label,
    tooltipText:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-ROIP-ID"]
        .tooltipText,

    name: "MAPPED-ROIP-ID",

    isInputInvalid: (val?: string) => {
      if (!val || val.length === 0) return true;
      return false;
    },
    invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-ROIP-ID"),
  },
  {
    type: "TEXT",
    label: ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DMR-ID"].label,
    tooltipText:
      ADD_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DMR-ID"]
        .tooltipText,
    name: "MAPPED-DMR-ID",
    isInputInvalid: (val?: string) => {
      if (!val || val.length === 0) return true;
      return false;
    },
    invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-DMR-ID"),
  },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_OTAR_CONNECTION_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["CONNECTION-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["CONNECTION-ID"]
            .tooltipText,
        name: "CONNECTION-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-IPV4-ADDR"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-IPV4-ADDR"]
            .tooltipText,
        name: "KMF-IPV4-ADDR",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }
          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-IPV4-ADDR"]
            .label
        ),
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-PORT"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-PORT"]
            .tooltipText,
        name: "KMF-PORT",
        min: 1024,
        max: 65535,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "KMF-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "KMF-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "KMF-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "IWF-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "MESSAGE-NUMBER-PERIOD"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "MESSAGE-NUMBER-PERIOD"
          ].tooltipText,
        name: "MESSAGE-NUMBER-PERIOD",
        min: 0,
        max: 65535,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["PRIVATE-CALL-SLN"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["PRIVATE-CALL-SLN"]
            .tooltipText,
        name: "PRIVATE-CALL-SLN",
        min: 0,
        max: 4095,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "GROUP-REGROUP-SLN"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "GROUP-REGROUP-SLN"
          ].tooltipText,
        name: "GROUP-REGROUP-SLN",
        min: 0,
        max: 4095,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OTAR-REGISTRATION-TIMER"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OTAR-REGISTRATION-TIMER"
          ].tooltipText,
        name: "OTAR-REGISTRATION-TIMER",
        min: 1,
        max: 72,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KEEP-ALIVE-TIMER"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KEEP-ALIVE-TIMER"]
            .tooltipText,
        name: "KEEP-ALIVE-TIMER",
        min: 0,
        max: 300,
      },
    ],
  },
  {
    cols: 3,
    fields: [
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-SEND-REKEY-REQ"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-SEND-REKEY-REQ"
          ].tooltipText,
        name: "OPT-SEND-REKEY-REQ",
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-DE-REGISTRATION"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-DE-REGISTRATION"
          ].tooltipText,
        name: "OPT-DE-REGISTRATION",
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-REVERSE-WARM-START"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-REVERSE-WARM-START"
          ].tooltipText,
        name: "OPT-REVERSE-WARM-START",
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-HELLO-MAC-REPLY"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-HELLO-MAC-REPLY"
          ].tooltipText,
        name: "OPT-HELLO-MAC-REPLY",
      },
      {
        type: "TOGGLE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-KEY-ASSIGNMENT"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-KEY-ASSIGNMENT"
          ].tooltipText,
        name: "OPT-KEY-ASSIGNMENT",
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ADD_IKI_CONNECTION_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["CONNECTION-ID"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["CONNECTION-ID"]
            .tooltipText,
        name: "CONNECTION-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (val.toUpperCase().includes("CONNECTION-IWF")) return true;
          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.reservedIdentifier({
          fieldName:
            ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["CONNECTION-ID"]
              .label,
          reservedWord: "Connection-IWF",
        }),
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"]
            .tooltipText,
        name: "IKI-NAME",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (val.toUpperCase().includes("IWF")) return true;
          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.reservedIdentifier({
          fieldName:
            ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"].label,
          reservedWord: "IWF",
        }),
      },
      {
        type: "TEXT",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"]
            .label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"]
            .tooltipText,
        name: "IKI-IPV4-ADDR",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"]
            .label
        ),
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-PORT"].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-PORT"]
            .tooltipText,
        name: "IKI-PORT",
        min: 1024,
        max: 65535,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IKI-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IKI-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "IKI-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
      {
        type: "NUMBER",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "IWF-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
    ],
  },
  {
    cols: 1,
    fields: [
      {
        type: "FILE",
        label:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "UPLOAD-CERTIFICATE"
          ].label,
        tooltipText:
          ADD_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "UPLOAD-CERTIFICATE"
          ].tooltipText,
        name: "UPLOAD-CERTIFICATE",
      },
    ],
  },
];
